import CloseIcon from '@mui/icons-material/Close';
import MuiTextField from '@mui/material/TextField';
import { useState } from 'react';
import { Button, Confirm, useNotify, useRecordContext } from 'react-admin';
import { useResourceAction } from '../hooks/useResourceAction';

type RejectButtonProps = {
  resource: string;
  pendingStatus: string;
  title: string;
  helperText: string;
  success: string;
  error: string;
};

// Reject-with-reason for the two reviewed resources (ads and advertiser applications).
export const RejectButton = ({
  resource,
  pendingStatus,
  title,
  helperText,
  success,
  error,
}: RejectButtonProps) => {
  const record = useRecordContext();
  const notify = useNotify();
  const reject = useResourceAction(resource, 'reject', { success, error });
  const [open, setOpen] = useState(false);
  const [reason, setReason] = useState('');

  if (record?.status !== pendingStatus) return null;

  const handleConfirm = async () => {
    if (!reason.trim()) {
      notify('Please provide a rejection reason', { type: 'warning' });
      return;
    }
    if (await reject({ reason })) {
      setOpen(false);
      setReason('');
    }
  };

  return (
    <>
      <Button
        label="Reject"
        onClick={() => setOpen(true)}
        startIcon={<CloseIcon />}
        color="error"
      />
      <Confirm
        isOpen={open}
        fullWidth
        title={title}
        confirm="Reject"
        confirmColor="warning"
        onConfirm={handleConfirm}
        onClose={() => setOpen(false)}
        content={
          /* Plain MUI TextField, not react-admin's <TextInput>: the dialog renders outside any
             form context, so <TextInput> (bound via react-hook-form's useController) ignored
             value/onChange and left `reason` empty — every reject hit the "reason required" guard. */
          <MuiTextField
            label="Rejection Reason"
            fullWidth
            multiline
            rows={4}
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            helperText={helperText}
            sx={{ mt: 1 }}
          />
        }
      />
    </>
  );
};
